import Vue from 'vue'
import Router from 'vue-router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.use(Router)

import Index from '@/components/Index'
import HTIndex from '@/admin/views/index/index'

var onetitle='-郑记面条后台管理';

export default new Router({
  mode:'history',
  routes: [
    /**
    {
    path: '/shxx',
    name: 'shxx',
    component: ()=>import('@/img_update/images_UP'),//页面redis测试
    children:[],
    meta:{title: "审核信息"}
    },
    **/
    {
    path: '/ceshipage',
    name: 'ceshipage',
    component: ()=>import('@/common/ceshipage'),//页面redis测试
    children:[],
    meta:{title: "拼音转换"}
    },
    {
    path: '/gamehome',
    name: 'gamehome',
    component: ()=>import('@/Game/Index'),//游戏选择界面
    children:[],
    meta:{title: "游戏家"}
    },
    {
    path: '/wzq',
    name: 'wzq',
    component: ()=>import('@/Game/WZQ'),//页面redis测试
    children:[],
    meta:{title: "五子棋"}
    },
    {
    path: '/pinyincs',
    name: 'pingyingcs',
    component: ()=>import('@/common/PingYingCS'),//首页主页
    children:[],
    meta:{title: "拼音转换"}
    },
    {
    path: '/rqewm',
    name: 'rqewm',
    component: ()=>import('@/common/NmcWXQ_PC'),//首页主页
    children:[],
    meta:{title: "入群二维码"}
    },
    {
      //用户主页
      path: '/',
      component: Index,
      children:[
        {
        path: '/',
        name: 'recommend',
        component: ()=>import('@/components/Recommend'),//首页主页
        children:[],
        },
        {
        path: '/404',
        name: '404',
        component: ()=>import('@/components/404'),//404页面
        children:[],
        },
        {
        path: '/applyText',
        name: 'applyText',
        component: ()=>import('@/components/applyText'),//支付跳转
        children:[],
        },
        {
        path: '/allgoods',
        name: 'allgoods',
        component: ()=>import('@/components/AllGoods'),//所有商品
        children:[],
        },
        {
        path: '/shoporder',
        name: 'shoporder',
        component: ()=>import('@/components/ShopOrder'),//商户订单
        children:[],
        },
        {
        path: '/confirmorder',
        name: 'confirmorder',
        component: ()=>import('@/components/ConfirmOrder'),//确认商品订单
        children:[],
        },
        {
        path: '/confirmshoporder',
        name: 'confirmshoporder',
        component: ()=>import('@/components/ConfirmShopOrder'),//确认商户商品订单
        children:[],
        },
        {
        path: '/goodsinfor',
        name: 'goodsinfor',
        component: ()=>import('@/components/GoodsInfor'),//商品详情
        children:[],
        },
        {
        path: '/car',
        name: 'car',
        component: ()=>import('@/components/Car'),//购物车
        children:[],
        },
        {
        path: '/message',
        name: 'message',
        component: ()=>import('@/components/Message'),//留言页面
        children:[],
        },
        {
        path: '/about',
        name: 'about',
        component: ()=>import('@/components/About'),//关于我们
        children:[],
        },
        {
        path: '/notice',
        name: 'notice',
        component: ()=>import('@/components/SystemNotice'),//系统通知
        children:[],
        },
        {
        path: '/users',
        name: 'users',
        component: ()=>import('@/components/User'),//个人前置主页
        children:[
          {
          path: '/users/self',
          name: 'self',
          component: ()=>import('@/components/Self'),//个人主页
          },
          {
          path: '/users/haddress',
          name: 'haddress',
          component: ()=>import('@/components/HAaddress'),//个人地址信息
          },
          {
          path: '/users/update',
          name: 'update',
          component: ()=>import('@/components/Update'),//个人信息修改
          },
          {
          path: '/users/myorder',
          name: 'myorder',
          component: ()=>import('@/components/OrderCeshi'),//通知消息
          },
          //{
          //path: '/users/myorder',
          //name: 'myorder',
          //component: ()=>import('@/components/MyOrder'),//个人订单信息
          //},
          //{
          //path: '/users/shoporderList',
          //name: 'shoporderList',
          //component: ()=>import('@/components/ShopOrderList'),//个人订单信息
          //},
          {
          path: '/users/Merchant_Ca',
          name: 'Merchant_Ca',
          component: ()=>import('@/components/Merchant_CA'),//个人订单信息
          },
          {
          path: '/users/consulation',
          name: 'consulation',
          component: ()=>import('@/components/ConsulationList'),//订单咨询
          },
          {
          path: '/users/consulationinfor',
          name: 'consulationinfor',
          component: ()=>import('@/components/Consulationinfor'),//订单咨询对话框
          },
          {
          path: '/users/inform',
          name: 'inform',
          component: ()=>import('@/components/Inform'),//通知消息
          },
        ],
        },
        {
        path: '/notify',
        name: 'notify',
        component: ()=>import('@/components/Notify'),//通知信息
        children:[
          {
          path: '/notify/sysnotice',
          name: 'SysNotice',
          component: ()=>import('@/components/SysNotice'),//个人订单信息
          },
          {
          path: '/notify/consulations',
          name: 'consulations',
          component: ()=>import('@/components/ConsulationLists'),//订单咨询
          },
          {
          path: '/notify/consulationinfors',
          name: 'consulationinfors',
          component: ()=>import('@/components/Consulationinfors'),//订单咨询对话框
          },
          {
          path: '/notify/inform',
          name: 'informs',
          component: ()=>import('@/components/Inform'),//通知消息
          },
        ],
        },
      ]
    }
    //测试用
    ,{
      path: '/ceshi',
      name: 'ceshi',
      component: ()=>import('@/components/ceshi'),
      children:[],
    },
    //付款跳回界面,用于更新付款信息
    {
    path: '/pay_exit',
    name: 'pay_exit',
    component: ()=>import('@/components/pay_exit'),//支付完成后关闭本页面
    children:[],
    },
    //管理员登录
    {
      path: '/alogin',
      name: 'alogin',
      component: ()=>import('@/admin/login/Alogin'),
      children:[],
      meta:{title: '登录'+onetitle}
    },
    {
      path: '/Aindex',
      component: HTIndex,
      children:[
        {
          path: '/Aindex/index',
          name: 'index',
          component: ()=>import('@/admin/views/index/Text'),
          children:[],
          meta:{title: "首页"+onetitle}
        },
        {
          path: '/Aindex/report',
          name: 'report',
          component: ()=>import('@/admin/views/index/Report'),
          children:[],
          meta:{title: '报表'+onetitle}
        },
        {
          path: '/Aindex/orderconfirm',
          name: 'orderconfirm',
          component: ()=>import('@/admin/views/system/OrderConfirm'),
          children:[],
          meta:{title: '下单控制'+onetitle}
        },
        {
          path: '/Aindex/userList',
          name: 'userList',
          component: ()=>import('@/admin/views/users/userList'),
          children:[],
          meta:{title: '用户'+onetitle}
        },
        {
          path: '/Aindex/massage',
          name: 'massage',
          component: ()=>import('@/admin/views/massage/Liuyan'),
          children:[],
          meta:{title: '留言'+onetitle}
        },
        {
          path: '/Aindex/app_feedback',
          name: 'app_feedback',
          component: ()=>import('@/admin/views/massage/APP_Feedback'),
          children:[],
          meta:{title: 'APP反馈'+onetitle}
        },
        {
          path: '/Aindex/notice',
          name: 'notice',
          component: ()=>import('@/admin/views/notice/Notice'),
          children:[],
          meta:{title: '通知'+onetitle}
        },
        {
          path: '/Aindex/a_notice',
          name: 'a_notice',
          component: ()=>import('@/admin/views/system/A_notice'),
          children:[],
          meta:{title: '后台公告'+onetitle}
        },
        {
          path: '/Aindex/about_our',
          name: 'about_our',
          component: ()=>import('@/admin/views/system/About_Our'),
          children:[],
          meta:{title: '关于我们管理'+onetitle}
        },
        {
          path: '/Aindex/download',
          name: 'download',
          component: ()=>import('@/admin/views/system/Download'),
          children:[],
          meta:{title: '下载管理'+onetitle}
        },
        {
          path: '/Aindex/logs',
          name: 'logs',
          component: ()=>import('@/admin/views/logs/Logs'),
          children:[],
          meta:{title: '日志'+onetitle}
        },
        {
          path: '/Aindex/authentication',
          name: 'authentication',
          component: ()=>import('@/admin/views/authentication/Authentication'),
          children:[],
          meta:{title: '商户认证'+onetitle}
        },
        {
          path: '/Aindex/category',
          name: 'category',
          component: ()=>import('@/admin/views/goods/Category'),
          children:[],
          meta:{title: '商品类别'+onetitle}
        },
        {
          path: '/Aindex/univalence',
          name: 'univalence',
          component: ()=>import('@/admin/views/goods/Univalence'),
          children:[],
          meta:{title: '商户单价'+onetitle}
        },
        {
          path: '/Aindex/goodslist',
          name: 'goodslist',
          component: ()=>import('@/admin/views/goods/GoodsList'),
          children:[],
          meta:{title: '商品列表'+onetitle}
        },
        {
          path: '/Aindex/orderlist',
          name: 'orderlist',
          component: ()=>import('@/admin/views/order/OrderList'),
          children:[],
          meta:{title: '订单'+onetitle}
        },
        {
          path: '/Aindex/lunbo',
          name: 'lunbo',
          component: ()=>import('@/admin/views/system/Lunbo'),
          children:[],
          meta:{title: '首页展示'+onetitle}
        },
        {
          path: '/Aindex/systemA',
          name: 'systemA',
          component: ()=>import('@/admin/views/systemAdmin/SystemA'),
          children:[],
          meta:{title: '管理员'+onetitle}
        },
        {
          path: '/Aindex/people',
          name: 'people',
          component: ()=>import('@/admin/views/systemAdmin/People'),
          children:[],
          meta:{title: '人员'+onetitle}
        },
        {
          path: '/Aindex/admin_type',
          name: 'admin_type',
          component: ()=>import('@/admin/views/systemAdmin/Admin_Type'),
          children:[],
          meta:{title: '权限'+onetitle}
        },
        {
          path: '/Aindex/ceshi',
          name: 'ceshi',
          component: ()=>import('@/admin/views/index/ceshi'),
          children:[],
          meta:{title: '测试'+onetitle}
        },
        {
          path: '/Aindex/updateinfor',
          name: 'updateinfor',
          component: ()=>import('@/admin/views/update/UpdateInfor'),
          children:[],
          meta:{title: '个人信息'+onetitle}
        },
        {
          path: '/Aindex/consulation',
          name: 'Aconsulation',
          component: ()=>import('@/admin/views/consulation_admin/AConsulationList'),
          children:[
            {
              path: '/Aindex/consulation/Aconsulationinfor',
              name: 'Aconsulationinfor',
              component: ()=>import('@/admin/views/consulation_admin/AConsulationinfor'),
              children:[],
            },
          ],
          meta:{title: '订单普通咨询'+onetitle}
        },
        //{
        //  path: '/Aindex/shoporderlist',
        //  name: 'shoporderlist',
        //  component: ()=>import('@/admin/views/order/ShopOrderList'),
        //  children:[],
        //},
      ],
    },

    //重定向路由
    {path: "*",redirect: "/404",meta:{title: '404，页面消失了'}},
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js